"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.stat.scheduled': 'Programado',
    'socialMediaPlan.stat.drafts': 'Borradores',
    'socialMediaPlan.stat.published': 'Publicado',
    'socialMediaPlan.stat.total': 'Total',
};
